/**
 * Microsoft's four-square mark, inlined because their brand guidelines require the logo in its own
 * colours next to "Sign in with Microsoft" — Tabler's `IconBrandWindows` is monochrome and is the
 * Windows logo rather than this one.
 */
const MicrosoftLogo = ({ size = 21 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 21 21" aria-hidden focusable="false">
    <rect x="0" y="0" width="10" height="10" fill="#f25022" />
    <rect x="11" y="0" width="10" height="10" fill="#7fba00" />
    <rect x="0" y="11" width="10" height="10" fill="#00a4ef" />
    <rect x="11" y="11" width="10" height="10" fill="#ffb900" />
  </svg>
);

export { MicrosoftLogo };
